import { ProgressIndicator } from '@/components/astro/blog/progress-indicator';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';

export function NavBarAndProgressIndicator() {
  return (
    <div className='sticky inset-x-0 top-0 z-50 flex flex-col border-b border-neutral-200 bg-white'>
      <NavBar />
      <div id='progress-indicator-container'>
        <ProgressIndicator />
      </div>
    </div>
  );
}
